import React from 'react';
import { Card, CardBody, Table, Progress, Button } from 'reactstrap';

const data = [
  {
    ref: 'R04007403',
    payment: 'Credit Card',
    date: '2025-06-11 11:34:57',
    sku: '179900121078',
    reason: 'Not Happy with Product Design',
    type: 'Return',
    mode: 'Refund',
    status: 'Return Authorized',
    progress: 0,
  },
  {
    ref: 'R04007403',
    payment: 'Credit Card',
    date: '2025-06-11 11:34:57',
    sku: '179900121078',
    reason: 'Wrong Color',
    type: 'Return',
    mode: 'Refund',
    status: 'Pending',
    progress: 3,
  },
  {
    ref: 'R04007403',
    payment: 'Credit Card',
    date: '2025-06-11 11:34:57',
    sku: '179900097619',
    reason: 'Not Happy with Product Quality',
    type: 'Return',
    mode: 'Refund',
    status: 'Completed',
    progress: 3,
  },
];

const getProgressColor = (status) => {
  if (status === 'Completed') return 'success';
  if (status === 'Pending') return 'danger';
  return 'secondary';
};

const RecentReturnRequestsTable = () => (
  <Card>
    <CardBody>
      <h5 className="mb-3">Recent Return Requests</h5>
      <Table responsive hover>
        <thead>
          <tr>
            <th>Sl.No</th>
            <th>Reference No</th>
            <th>SKU</th>
            <th>Reason</th>
            <th>Request Type</th>
            <th>Resolution Mode</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx}>
              <td>{idx + 1}</td>
              <td>
                <div>
                  <span className="fw-bold">{row.ref}</span>
                  <br />
                  <span className="text-muted" style={{ fontSize: 12 }}>
                    Payment Mode: <b>{row.payment}</b>
                    <br />
                    Date: {row.date}
                    <br />
                    Created By: Customer
                  </span>
                </div>
              </td>
              <td>{row.sku}</td>
              <td>{row.reason}</td>
              <td>{row.type}</td>
              <td>{row.mode}</td>
              <td>
                <div>
                  <span>{row.status}</span>
                  <Progress
                    value={row.progress}
                    color={getProgressColor(row.status)}
                    style={{ height: 6 }}
                    className="mt-1"
                  />
                  <span style={{ fontSize: 12 }}>{row.progress}%</span>
                </div>
              </td>
              <td>
                <Button color="warning" outline size="sm">
                  <i className="bx bx-show"></i>
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </CardBody>
  </Card>
);

export default RecentReturnRequestsTable;
